import React from "react"
import types from "prop-types"
import { FormsyTextInput } from "shared/inputs"

const UserFirstName = ({ user }) => (
  <div className="mr-3">
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label>First Name</label>
    <FormsyTextInput
      className="mb-3 mt-1 bordered-base-input text-sm"
      name="first_name"
      placeholder="First Name"
      value={user.first_name || ""}
      required
      validations={{ isNotBlankString: true }}
      validationErrors={{ isDefaultRequiredValue: "required" }}
    />
  </div>
)

UserFirstName.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: types.object.isRequired,
}

export default UserFirstName
